import { render } from "./ProjectPublicationsCreateFormMessage.vue?vue&type=template&id=361656c1"
import script from "./ProjectPublicationsCreateFormMessage.vue?vue&type=script&lang=js"
export * from "./ProjectPublicationsCreateFormMessage.vue?vue&type=script&lang=js"

import "./ProjectPublicationsCreateFormMessage.vue?vue&type=style&index=0&id=361656c1&lang=scss"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__